import CryptoJS from "crypto-js";

const key = process.env.REACT_APP_SECRET_KEY;
const encryptionIV = process.env.REACT_APP_SECRET_IV;

// CryptoJS en mode CBC exige key et IV comme WordArray. Passer une string ou undefined
// provoque l'erreur "cannot read properties of undefined (reading 'words')".
function getKeyAndOptions() {
  if (!key || key === "" || !encryptionIV || encryptionIV === "") {
    throw new Error(
      "Variables d'environnement manquantes : REACT_APP_SECRET_KEY et REACT_APP_SECRET_IV doivent être définies (fichier .env ou build Docker)."
    );
  }
  const keyWA = CryptoJS.enc.Utf8.parse(key);
  const ivParsed = CryptoJS.enc.Utf8.parse(encryptionIV);
  // IV doit faire 16 octets pour AES-CBC
  const ivWA =
    ivParsed.sigBytes >= 16
      ? CryptoJS.lib.WordArray.create(ivParsed.words.slice(0, 4), 16)
      : ivParsed;

  return {
    keyWA,
    options: {
      iv: ivWA,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  };
}

export function encryptData(data) {
  const { keyWA, options } = getKeyAndOptions();
  const cipher = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    keyWA,
    options
  );
  return cipher.toString();
}

export function decryptData(data) {
  try {
    const { keyWA, options } = getKeyAndOptions();
    const cipher = CryptoJS.AES.decrypt(data, keyWA, options);
    const str = cipher.toString(CryptoJS.enc.Utf8);
    return str !== "" ? JSON.parse(str) : str;
  } catch (error) {
    return null;
  }
}
